// ----------------- START BEGIN CHECKOUT SCRIPT ------------------------------------
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});

function breezeInitiateCheckout(payload) {
  try {
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}

function merchantInitiateCheckoutCustomCode(params) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "AW-802578154");

  gtag("event", "Started Order", {
    send_to: [ "G-3EFRBRMYML"],
    ignore_referrer: "true",
    breeze_event_type: "breeze_started_order",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "begin_checkout", {
    send_to: ["G-3EFRBRMYML", "AW-802578154/cuyyCM-qzIcBEOq92f4C"],
    ecomm_totalvalue: params.totalPrice,
    value: params.totalPrice,
    currency: params.currency,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_begin_checkout",
    breeze_event_send_to: ["G","AW"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "page_view", {
    send_to: ["G-3EFRBRMYML", "AW-802578154/cuyyCM-qzIcBEOq92f4C"],
    page_title: "Checkout - Contact Information",
    page_location: getCurrentPageUrl(),
    ecomm_totalvalue: params.totalPrice,
    value: params.totalPrice,
    currency: params.currency,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_send_to: ["G","AW"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "Viewed Checkout - Shipping Page", {
    send_to: ["G-3EFRBRMYML"],
    event_category: "All",
    ecomm_totalvalue: params.totalPrice,
    value: params.totalPrice,
    currency: params.currency,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_viewed_checkout_shipping_page",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });
}
// ----------------- END BEGIN CHECKOUT SCRIPT ------------------------------------



// ----------------- START ADD PAYMENT INFO SCRIPT ------------------------------------
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});

function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}

function merchantAddPaymentInfoCustomCode(params) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "AW-802578154");

  gtag("event", "add_payment_info", {
    send_to: [
      "G-3EFRBRMYML", "AW-802578154/VR1UCM2rzIcBEOq92f4C"
    ],
    page_location: getCurrentPageUrl(),
    ignore_referrer: "true",
    breeze_event_type: "breeze_add_payment_info",
    breeze_event_send_to: ["G", "AW"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "Viewed Checkout - Processing Page", {
    send_to: ["G-3EFRBRMYML"],
    event_category: "All",
    currency: params.totalPrice,
    total: params.itemCount,
    ignore_referrer: "true",
    breeze_event_type: "breeze_viewed_checkout_processing_page",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "page_view", {
    send_to: ["G-3EFRBRMYML",
    "AW-802578154/yQmyCNOozIcBEOq92f4C",
    "MC-XVP9VYQV1P"],
    page_path: "/checkout/processing",
    page_title: "Checkout - Processing",
    page_location: getCurrentPageUrl(),
    currency: params.totalPrice,
    total: params.itemCount,
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_send_to: ["G","AW","MC"],
    breeze_event_time: new Date().toISOString(),
  });
  
}
// ----------------- END ADD PAYMENT INFO SCRIPT ------------------------------------


// ----------------- START PURCHASE SCRIPT ------------------------------------
window.addEventListener("breeze-purchase", (event) => {
  const eventData = event.detail;
  breezePurchase(eventData);
});

function breezePurchase(payload) {
  try {
    merchantPurchaseCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants purchase script : ", e);
  }
}

function merchantPurchaseCustomCode(params) {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "AW-802578154");

  gtag("event", "Completed Order", {
    send_to: ["G-3EFRBRMYML"],
    event_category: "EnhancedEcommerce",
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_completed_order",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "Viewed Checkout - Receipt Page", {
    send_to: ["G-3EFRBRMYML"],
    event_category: "All",
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_viewed_checkout_receipt_page",
    breeze_event_send_to: ["G"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "page_view", {
    send_to: ["G-3EFRBRMYML",
    "AW-802578154/yQmyCNOozIcBEOq92f4C",
    "MC-XVP9VYQV1P"],
    page_path: "/checkout/thank_you",
    page_title: "Checkout - Receipt",
    page_location: getCurrentPageUrl(),
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_page_view",
    breeze_event_send_to: ["G","AW","MC"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "purchase", {
    send_to: ["G-3EFRBRMYML",
    "AW-802578154/gkH5CNaozIcBEOq92f4C",
    "MC-XVP9VYQV1P"],
    value: params.totalPrice,
    currency: params.currency,
    transaction_id: params.shopOrderId,
    shipping: params.shippingCharge,
    items: getConvertedItems(params.items),
    ignore_referrer: "true",
    breeze_event_type: "breeze_purchase",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });

  gtag("event", "conversion", {
    send_to: ["G-3EFRBRMYML",
    "AW-802578154/gkH5CNaozIcBEOq92f4C",
    "MC-XVP9VYQV1P"],
    value: params.totalPrice,
    currency: "INR",
    transaction_id: params.shopOrderId,
    triggered_by: "Breeze",
    breeze_event_type: "breeze_conversion",
    breeze_event_send_to: ["AW"],
    breeze_event_time: new Date().toISOString(),
  });
}

// ----------------- ENDS PURCHASE SCRIPT ------------------------------------














// ----------------- Common Helper Functions ----------------------------------

// function to get the screen resolution in particular format (i.e. '2560x1440')
function getScreenResolution() {
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  return screenHeight + "x" + screenWidth;
}
// function to return language used in GA config (i.e. "en-gb", "en-us")
function getLanguage() {
  return "en-gb";
}
// function to return order complete page title
function getGAOrderCompleteTitle() {
  return "Breeze Checkout Thank You Page";
}
// function to return GA clientId if present or
function getGAClientIDfromMeasurementID() {
  try {
    var match = document.cookie.match("(?:^|;)\\s*_ga=([^;]*)"),
      raw = match ? decodeURIComponent(match[1]) : null;
    if (raw) {
      match = raw.match(/(\d+\.\d+)$/);
    }
    return match ? match[1] : null;
  } catch (e) {
    console.log("Exception: unable to get GA clientId");
  }
  return null;
}
// function to return merchants domain
function getMerchantDomain() {
  try {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split(".");
    const tld = domainParts.slice(-2).join(".");
    return tld;
  } catch (e) {
    console.log("Exception: unable to get merchant domain");
  }
  return null;
}
// function to return current page url
function getCurrentPageUrl() {
  return window.location.href;
}
// function to return converted cart items
function getConvertedItems(items) {
  return items.map((item) => {
    return {
      id: item.id,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
      variant: item.variant,
    };
  });
}
